export const VI_CONFIG = {
  LOGIN_THRESHOLD_SECONDS: 600000,
  DOMAINS: ['vitest.modalx.ai', 'vi.modalx.ai', 'localhost'],
  USER_EMAIL_SUFFIX: '@vodafoneuser.com',
  LOCALSTORAGE_HANDSHAKE_KEY: 'requestTimestamp',
};

export const isViDomain = () => {
  const hostname = window.location.hostname;
  console.log('hostname', hostname);
  console.log('isViDomain', VI_CONFIG.DOMAINS.includes(hostname));
  return VI_CONFIG.DOMAINS.includes(hostname);
};

export const isViUser = () => {
  return localStorage.getItem('isViUser') === 'true';
};

export const isViAutoGeneratedEmail = (email) => {
  if (!email) return false;
  return email.endsWith(VI_CONFIG.USER_EMAIL_SUFFIX);
};

export const isViRealName = (firstName) => {
  if (!firstName) return false;
  if (firstName.startsWith('__') || firstName.startsWith('-')) return false;
  const email = localStorage.getItem('userEmail');
  const emailPrefix = email?.split('@')[0];
  return firstName !== emailPrefix;
};
